import { SelectBoxOpt } from '@/components/content/SelectBox'
import { OutboundScheduleShipperCode } from './types/query'

export const PLATFORM_OPTIONS: SelectBoxOpt<OutboundScheduleShipperCode>[] = [
  { label: 'MUSINSA', value: 'MUSINSA' },
  { label: '29CM', value: '29CM' },
  { label: 'MUSINSA_USED', value: 'MUSINSA_USED' },
]

/** 이 화면의 2.0 화면코드 — 같이 쓰는 수용량 API 에 X-Menu-Code 로 실어 감사 로그 MENU_CD 를 가른다(LOGISPRD-15645) */
export const MENU_CODE = 'GI27'
